import { Outlet } from "react-router";
import type { LocaleHandle } from "~/app/lib/locale";

export const handle: LocaleHandle = { locale: "en" };

export default function MarketingLayoutEN() {
  return <Outlet />;
}
